import React from 'react'
import './aboutprotocol.scss'
import { useTheme } from '../../../contexts/ThemeProvider'
import { LIGHT_THEME } from '../../../utils/constants';

const AboutProtocol = () => {
    const { theme } = useTheme();
    return (
        <>

            <section className='protocol'>
                <div className="custom-container protocol_main">
                    <div className="protocol_left">
                        <h3 className='about_common_heading'>Our Protocol</h3>
                        <p className='about_p'>
                            Rain is an open protocol designed to be the foundational infrastructure for prediction markets at a global scale.
                            <span>
                                Built on Arbitrum, the protocol also features cross-chain support, allowing users to deposit funds from other networks like Ethereum, Base, and BNB Chain for a seamless experience. Our goal is to remove the typical barriers of Web3, like complex wallet interactions and gas fees, to make participation straightforward for everyone.
                            </span>
                            <span>
                                A core principle of Rain is true decentralization. We are <span className='span_bold'>the first and only protocol</span> that gives users the power to create their own <span className="span_bold">private, invitation-only markets</span> - perfect for organizations, teams, or communities forecasting internal outcomes. Alongside this, anyone can create public markets for global events, making Rain a truly permissionless platform.
                            </span>
                            <span>
                                The protocol is governed by a decentralized autonomous organization (DAO), where holders of the $RAIN token can propose and vote on the platform's future.
                            </span>
                        </p>
                    </div>
                </div>
                {theme != LIGHT_THEME ?
                    window.innerWidth > 991 ?
                        <img src="/assets/about/protocol.png" alt="protocol" /> :
                        <img src="/assets/about/protocol-mb.png" alt="protocol" /> :
                    window.innerWidth > 991 ?
                        <img src='/assets/about/protocol-light.png' alt='protocol' /> :
                        <img src="/assets/about/protocollight-mb.png" alt="protocol" />
                }
                {theme != LIGHT_THEME ?
                    <div className='shadow'></div> :
                    <div className='shadow_light'></div>
                }
            </section>

        </>
    )
}

export default AboutProtocol